import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Address } from 'projects/Widget/src/app/business-entities/address-model';
import { CreateContactRequestModel } from 'projects/Widget/src/app/business-entities/create-contact-request-model';
import { CustomerVehicleDetailsMultiple } from 'projects/Widget/src/app/business-entities/customer-vehicle-response.interface';
import { Features } from 'projects/Widget/src/app/business-entities/step.class';
import { SettingService } from 'projects/Widget/src/app/business-services/setting.service';
import { CommonService } from 'projects/Widget/src/app/services/commom.service';
import { CultureLocaleService } from 'projects/Widget/src/app/services/culture-locale.service';
import { CityModel } from '../../../../../../../Administration/src/app/business-entities/customer-view.model';
import { ModelType, VehicleTransmission } from '../../../../../../../Administration/src/app/business-entities/vehicle-list-view-model';
import { CustomerService } from '../../../../business-services/customer.service';
import { AddVehicleCustomerModel } from '../../../../business-entities/add-vehicle-customer-model';
import { DFVehicleModel, VehiclesViewModel } from '../../../../business-entities/df-vehicle-details-model';
import { VehicleGroup } from '../../../../business-entities/vehiclegroup-model';
import { WidgetCustomerVehicleDetails } from '../../../../business-entities/widget-customer-vehicle-details-model';
import { VehicleType } from './../../../../../../../Administration/src/app/business-entities/vehicleTypes-model';
import * as CommonEnums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { Brand, BrandViewModel } from './../../../../business-entities/brand.interface';
import { CountryNameAndMobileCode } from './../../../../business-entities/country-name-and-mobile-code.interface';
import { Fuel } from './../../../../business-entities/fuel.interface';
import { FindCarService } from './../../../../business-services/find-car.service';
import { SummaryService } from 'projects/Widget/src/app/business-services/summary.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CountryISO } from 'ngx-intl-tel-input-gg';


@Component({
  selector: 'app-add-vehicle-customer',
  templateUrl: 'add-vehicle-customer.component.html',
  styleUrls: ['./add-vehicle-customer.component.css']
})
export class AddVehicleCustomerComponent implements OnInit {
  showVehicleDetails:boolean = false;
  brandDropdown: Brand[] = [];
  countryDropdown: CountryNameAndMobileCode[] = [];
  fuels: Fuel[] = [];
  vehicleTypes: VehicleType[] = []
  features: Features[] = [];
  dmsFeature: Features;
  vehicleCustomerDetailsMultiple: CustomerVehicleDetailsMultiple;
  CustomerVehicleForm: FormGroup;
  carColor: string;
  mobileNumber: string;
  userInputMobilecode?: string = '';
  userInputCountryCode: string;
  appData:any;
  mobileFormValue:boolean;
  customerFormValue:boolean;
  vehicle:VehiclesViewModel;
  ownertypes:any[] =[];
  ownertype:any ={};
  isDFVehicleFound:boolean = true;
  postCodeList: any;
  postCodeRawData: any;
  cityList: CityModel[];
  makeList: BrandViewModel[] ;
  modelList: ModelType[] = [];
  vehicleTransmissionList: VehicleTransmission[] = [];
  vehicleGroupList:VehicleGroup[] = [];
  ownerName:string;
  currentYear:number;
  isWidgetVehicleDMSSearch: boolean;
  modelNo:any;
  isCustomerVehicleFormSubmited: boolean = false;
  isEmailChange: boolean = false;
  FirstRegDate: string = "";
  LastRegDate: string = "";
  InspectionPrevDate: string = "";
  InspectionNextDate: string = "";
  isShowDate:boolean=false;
  isMobileReadOnly:boolean = true;
  @Input() registrationNumber: string;
  @Input() mobileNo: string;
  @Input() mobileCode: string;
  @Input() vehicleDetails: DFVehicleModel;
  @Input() localVehicleDetails: WidgetCustomerVehicleDetails;
  @Input()
  public set mobileForm(val: boolean) {
   this.mobileFormValue = val;
  }

  @Input()
  public set customerForm(val: boolean) {
   this.customerFormValue = val;
    if(!this.customerFormValue)
    {
      this.disableCustomerControls();
    }
  }
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly fcService: FindCarService,
    private readonly spinner: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly commonService: CommonService,
    private readonly service: CustomerService,
    private readonly settingService: SettingService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly summaryService: SummaryService,
    private readonly secureStorage: SecureStorage
  ) { }

  ngOnInit(): void {
    this.onlyCountries= Constant.OnlyCountry;
    this.countryDialCodes= Constant.CountryDialCodes;
    this.currentYear=new Date().getFullYear();
    this.vehicle = (this.vehicleDetails!=undefined)?this.vehicleDetails.vehicles[0]:null;
    this.initializeForm();
    this.getAllData();
    this.appData = this.commonService.getAppData();
    this.ownertype.Payer = "";
    this.ownertype.User = "";
    this.ownertype.Driver = "";
    this.ownertype.Owner = "";
    this.getPostCodeDropdown();
    this.getFeatures();
    if(localStorage.getItem("Theme") == Constant.BnhInterface){
      this.isShowDate = true;
    }
    this.telInputObject();
  }

  async getFeatures() {
    this.currentLanguageService.featureList.subscribe((res) => {
      if(res?.length > 0){
        this.features = this.settingService.features;        
        let WidgetVehicleDMSSearch = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WidgetVehicleDMSSearch)?.isActive;
        this.isWidgetVehicleDMSSearch = WidgetVehicleDMSSearch;
        this.dmsFeature = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.DMS)
        let WSSBLP = this.features.find(x=>x.featureCode===CommonEnums.FeatureCode.WSSBLP)?.isActive;
        this.isMobileReadOnly = WSSBLP;
      }
    });
    
  }

  async getAllData(): Promise<void> {
    this.GetAllMake();
    this.GetAllFuelTypes();
    this.GetVehicleGroup();
    this.countryDropdownDetails();
    this.GetVehicleTransmission();
  }
  onCheckPayerChange(value){
    if(value.currentTarget.checked)
        this.ownertypes.push("Payer");
    else if(!value.currentTarget.checked){
      this.ownertypes.forEach((element,index)=>{
        if(element=="Payer") this.ownertypes.splice(index,1);
     });
    }
  }
  onCheckUserChange(value){
    if(value.currentTarget.checked)
        this.ownertypes.push("User");
    else if(!value.currentTarget.checked){
        this.ownertypes.forEach((element,index)=>{
    if(element=="User") this.ownertypes.splice(index,1);
 });
}
  }
  onCheckDrvierChange(value){
    if(value.currentTarget.checked)
      this.ownertypes.push("Driver");
    else if(!value.currentTarget.checked){
      this.ownertypes.forEach((element,index)=>{
    if(element=="Driver") this.ownertypes.splice(index,1);
 });
}
  }
  onCheckOwnerChange(value){
    if(value.currentTarget.checked)
      this.ownertypes.push("Owner");
    else if(!value.currentTarget.checked){
      this.ownertypes.forEach((element,index)=>{
    if(element=="Owner") this.ownertypes.splice(index,1);
 });
}
  }

  ValidateEmail(){
    this.isEmailChange =true;
  }

  async GetVehicleGroup(): Promise<void> {
    this.spinner.show();
    await this.fcService.getVehicleTypes()
      .then((result) => {
       this.spinner.hide();
       this.vehicleGroupList = result.responseObject?.result.filter(x=>x.isDisplay) as VehicleGroup[];
     });
  }

  GetAllMake(){
     this.makeList = this.summaryService.brandList;
  }

  async onMakeSelected(make: string) {
    this.CustomerVehicleForm.patchValue({
        makeName : make
    })
    if (make?.trim()) {
      this.GetAllModel(make);
    } else {
      this.modelList = [];
      this.CustomerVehicleForm.patchValue({
        Model : null
    })
    }
  }

  async GetAllModel(make: string): Promise<void> {
    await this.fcService.GetModelnoDropdownList(make).then(data => {
      this.modelList = data.responseObject;
    });
  }

   async GetVehicleTransmission(): Promise<void> {
     await this.fcService.GetVehicleTransmissionDropdownList().then(data => {
       this.vehicleTransmissionList = data.responseObject;
     });
   }

  async countryDropdownDetails(): Promise<void> {
    this.spinner.show();
    await this.fcService.getCountryCodeAndMobileCodeDetails()
      .then((result) => {
        this.spinner.hide();
        // if(localStorage.getItem("Theme") == Constant.BnhInterface){
        //   this.countryDropdown = result.responseObject.result as CountryNameAndMobileCode[];
        // }
        // else{
          this.countryDropdown =  result.responseObject.result.filter(x => x.isDisplay);
        //}
      });
  }
  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }

  BindPostData(city) {
    if (city) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
      this.CustomerVehicleForm.patchValue({
        Zipcode : this.postCodeList[0].code,
        City : city,
        CountryId : this.countryDropdown[0].id
      })
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }

  BindCityData(post) {
    if (post) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.CustomerVehicleForm.patchValue({
        Zipcode : post,
        City : this.cityList[0],
        CountryId : this.countryDropdown[0].id
      })
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  async onPostCodeSelected(postCode: string) {
    this.service.customerListRequest.postCode = postCode;
    if (postCode) {
      this.BindCityData(postCode);
    } else {
      this.postCodeList = this.postCodeRawData;
      this.service.customerListRequest.city = "";
      this.CustomerVehicleForm.patchValue({
        City : null,
        CountryId : null
      })
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  async onCitySelected(city: string) {
    this.service.customerListRequest.city = city;
    if (city) {
      this.BindPostData(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.service.customerListRequest.postCode = "";
      this.CustomerVehicleForm.patchValue({
        Zipcode : null,
        CountryId : null
      })
      this.postCodeList = this.postCodeRawData;
    }
  }
  async GetAllFuelTypes(): Promise<void> {
    this.spinner.show();
    await this.fcService.getFuelTypeDetails()
      .then((result) => {
        this.spinner.hide();
      this.fuels =result.responseObject.result as Fuel[];
    });
  }
  onCustomerVehicleFormSubmit(): void {
    this.isCustomerVehicleFormSubmited = true;
    let OwnerTypeRequired = this.translate.instant('lblOwnerTypeRequired')
    if(!this.isWidgetVehicleDMSSearch && this.ownertypes.length <=0){
      this.toastr.error(OwnerTypeRequired);
      return;
    }
    if(this.CustomerVehicleForm.value.Year>this.currentYear)
    {
      let ErrorMsg = this.translate.instant('lblEnterValidYear');
      this.toastr.error(ErrorMsg);
      return;
    }

    const viewModel: AddVehicleCustomerModel = this.createAddCustomerVehicleResponseModel();
    this.spinner.show();
    this.commonService.addNewVehicleCustomer(viewModel);
    this.toastr.success(CommonEnums.ToastrMessages.DetailsAdded);
    this.activeModal.close({ success: true, licensePlate: this.CustomerVehicleForm.controls.LicensePlate.value, mobileCode: this.userInputMobilecode,mobileNumber: this.CustomerVehicleForm.controls.MobileNo.value?.number ? this.CustomerVehicleForm.controls.MobileNo.value.number.toString().replace(/\s+/g, '') : this.CustomerVehicleForm.controls.MobileNo.value});
    this.spinner.hide();
  }

  onContactFormSubmit() {
    let contactInfo: CreateContactRequestModel = {
      accountId: '',
      countryCode: 'FI',
      email: this.CustomerVehicleForm.get('Email').value,
      firstName: this.CustomerVehicleForm.get('FirstName').value,
      lastName: this.CustomerVehicleForm.get('LastName').value,
      mobilePhone: this.CustomerVehicleForm.get('MobileNo').value?.number ? this.CustomerVehicleForm.get('MobileNo').value.number.toString().replace(/\s+/g, '') : this.CustomerVehicleForm.get('MobileNo').value,
      customerGroup: '',
      address: this.fillAddressModel()
    }

    let errorMessage = this.translate.instant("lblErrorMessage");
    let WarningMessage = this.translate.instant("lblErrorWarningForValue")

    let successMessage = "";
    successMessage = this.translate.instant("lblContactAddedSuccessfully");
    this.spinner.show();
    this.fcService.CreateContact(contactInfo).then((response) => {
      if(response.responseObject) {
        this.appData.driverId = response.responseObject.result.dataObject
        this.fcService.AssignDriverToVehicle(this.commonService.vehicleId, this.appData.driverId)
          .then((_result) => {
            if(response.responseObject.error) {
              // This is intentional
              
            }
          },
          (err) => {
            this.spinner.hide();
            if (err.status === Constant.BadRequest) {
              this.toastr.warning(WarningMessage);
            }
            else {
              this.toastr.error(errorMessage);
            }
          });
      }
    },
    (error) => {
      this.spinner.hide();
      if (error.status === Constant.BadRequest) {
        this.toastr.warning(WarningMessage);
      }
      else {
        this.toastr.error(errorMessage);
      }
    });
  }

  fillAddressModel(): Address {
    let addressInfo: Address = {
      street1: this.CustomerVehicleForm.get('Address1').value,
      street2: this.CustomerVehicleForm.get('Address2').value,
      street3: '',
      city: this.CustomerVehicleForm.get('City').value,
      postalCode: this.CustomerVehicleForm.get('Zipcode').value
    }
    return addressInfo;
  }

  handleAddCustomerVehicleError(errorObject: any) {
    let LicensePlateRequire = this.translate.instant('lblLicencePlateIsRequired.')
    let LicensePlateAlreadyExists = this.translate.instant('lblLicensePlateAlreadyExists')
    let AddFailed = this.translate.instant('lblCustomerVehilceAddFailed')
    if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.LicensePlateNotFoundErrorCode) {
      this.toastr.error(LicensePlateRequire);
    } else if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.ParamNotFoundErrorCode) {
      this.toastr.error(AddFailed);
    } else if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.CountryCodeNotFoundErrorCode) {
      this.toastr.error(AddFailed);
    } else if (errorObject && errorObject.errorCode === CommonEnums.ErrorCodes.LicensePlateAlreadyExistsErrorCode) {
      this.toastr.error(LicensePlateAlreadyExists);
    }
  }

  createAddCustomerVehicleResponseModel(): AddVehicleCustomerModel {
    this.telInputObject();
    if(this.modelList.length>0)
      this.modelNo=this.modelList.filter(x=>x.description===this.CustomerVehicleForm.controls.Model.value)[0].modelNo;
    if(this.vehicle == null){
      if(this.CustomerVehicleForm.value.Year == "") this.CustomerVehicleForm.patchValue({Year : 0})
      return {
        ...this.CustomerVehicleForm.value,
        Color: this.carColor,
        MobileNo: this.CustomerVehicleForm.controls.MobileNo.value?.number ? this.CustomerVehicleForm.controls.MobileNo.value.number.toString().replace(/\s+/g, '') : this.CustomerVehicleForm.controls.MobileNo.value,
        CountryId: this.CustomerVehicleForm.controls.CountryId.value,
        sourceOfCreation:'Widget',
      MobileCode:this.CustomerVehicleForm.controls.MobileNo.value?.dialCode,
      ownertypes:this.ownertypes,
      chasisNo:this.CustomerVehicleForm.controls.VinNumber.value,
      existingVehicleId : (this.localVehicleDetails) ? this.localVehicleDetails.existingVehicleId : null,
      vehicleGuid : (this.localVehicleDetails) ? this.localVehicleDetails.vehicleGuid : null,
      ModelNo:this.modelNo?this.modelNo:'',
      previousKilometer:(this.localVehicleDetails) ? this.localVehicleDetails.previousKilometer : 0,
    }
  }
    else{
    if(this.CustomerVehicleForm.value.Year == "") this.CustomerVehicleForm.patchValue({Year : 0})
    return {
      ...this.CustomerVehicleForm.value,
      Color: this.carColor,
      MobileNo: this.CustomerVehicleForm.controls.MobileNo.value?.number ? this.CustomerVehicleForm.controls.MobileNo.value.number.toString().replace(/\s+/g, '') : this.CustomerVehicleForm.controls.MobileNo.value,
      CountryId: this.CustomerVehicleForm.controls.CountryId.value,
      sourceOfCreation:'Widget',
    MobileCode:this.CustomerVehicleForm.controls.MobileNo.value?.dialCode,
    ownertypes:this.ownertypes,
    chasisNo : this.vehicle.vehicleIdentificationNumber,
    ModelNo:this.modelNo?this.modelNo:'',
    complianceNumber :this.vehicle.complianceNumber,
    registrationLastDate :this.vehicle.lastRegistrationDate,
    registrationDate :this.vehicle.firstRegistrationDate,
    totalWeight :this.vehicle.totalWeight,
    curbWeight:this.vehicle.curbWeight,
    noOfAxles:this.vehicle.noOfAxles,
    axleWeightLimitFront:this.vehicle.axleWeightLimit_Front,
    axleWeightLimitRear:this.vehicle.axleWeightLimit_Rear,
    tyreDimensionFront:this.vehicle.tyreDimension_Front,
    tyreDimensionRear:this.vehicle.tyreDimension_Rear,
    tyreLoadIndexFront:this.vehicle.tyreLoadIndex_Front,
    tyreLoadIndexRear:this.vehicle.tyreLoadIndex_Rear,
    tyreSpeedIndexFront:this.vehicle.tyreSpeedIndex_Front,
    tyreSpeedIndexRear:this.vehicle.tyreSpeedIndex_Rear,
    inspectionNextDate:this.vehicle.nextInspectionDate,
    inspectionPrevDate:this.vehicle.previousInspectionDate,
    ownername: this.ownerName,
    vehicleGuid : this.vehicle.vehicleId
    };
  }
    }
  onselectCountry(value: string)
  {
    this.userInputMobilecode  = this.countryDropdown.filter(x => x.id.toString() == value)[0].mobileCode.toString().split('+')[1];
    this.telInputObject();
  }



  setCustomerDetailsInForm() {
    this.CustomerVehicleForm.patchValue({
      MobileNo: this.vehicleCustomerDetailsMultiple.customerDetails.mobileNo,
      FirstName: this.vehicleCustomerDetailsMultiple.customerDetails.firstName,
      LastName: this.vehicleCustomerDetailsMultiple.customerDetails.lastName,
      Email: this.vehicleCustomerDetailsMultiple.customerDetails.email,
      Address1: this.vehicleCustomerDetailsMultiple.customerDetails.address1,
      Address2: this.vehicleCustomerDetailsMultiple.customerDetails.address2,
      City: this.vehicleCustomerDetailsMultiple.customerDetails.city,
      CountryId: this.vehicleCustomerDetailsMultiple.customerDetails.countryId,
      Zipcode: this.vehicleCustomerDetailsMultiple.customerDetails.zipcode
    });
    this.telInputObject();
  }

  disableCustomerControls() {
    if (this.CustomerVehicleForm) {
      this.CustomerVehicleForm.controls.MobileNo.disable();
      this.CustomerVehicleForm.controls.FirstName.disable();
      this.CustomerVehicleForm.controls.LastName.disable();
      this.CustomerVehicleForm.controls.Email.disable();
      this.CustomerVehicleForm.controls.Address1.disable();
      this.CustomerVehicleForm.controls.Address2.disable();
      this.CustomerVehicleForm.controls.City.disable();
      this.CustomerVehicleForm.controls.CountryId.disable();
      this.CustomerVehicleForm.controls.Zipcode.disable();
    }
  }

  get CustomerVehicleFormControls(): any {
    return this.CustomerVehicleForm.controls;
  }

  emptyCustomerForm(): void {
    this.enableCustomerControls();
    this.resetCustomerControls();
    this.setMobileNumberControl();
  }

  enableCustomerControls() {
    this.CustomerVehicleForm.controls.FirstName.enable();
    this.CustomerVehicleForm.controls.LastName.enable();
    this.CustomerVehicleForm.controls.Email.enable();
    this.CustomerVehicleForm.controls.Address1.enable();
    this.CustomerVehicleForm.controls.Address2.enable();
    this.CustomerVehicleForm.controls.City.enable();
    this.CustomerVehicleForm.controls.CountryId.enable();
    this.CustomerVehicleForm.controls.Zipcode.enable();
  }

  resetCustomerControls() {
    this.CustomerVehicleForm.controls.FirstName.reset();
    this.CustomerVehicleForm.controls.LastName.reset();
    this.CustomerVehicleForm.controls.Email.reset();
    this.CustomerVehicleForm.controls.Address1.reset();
    this.CustomerVehicleForm.controls.Address2.reset();
    this.CustomerVehicleForm.controls.City.reset();
    this.CustomerVehicleForm.controls.CountryId.reset();
    this.CustomerVehicleForm.controls.Zipcode.reset();
  }

  setMobileNumberControl() {
    this.CustomerVehicleForm.patchValue({
      MobileNo: this.mobileNo
    });
  }

  initializeForm(): void {
    let mobile = null;
    if (this.mobileNo) {
      mobile = this.mobileNo;
    }

    let vinNumber = this.registrationNumber.length>= 11 ? this.registrationNumber : '';
    let registerNumber = this.registrationNumber.length< 11 ? this.registrationNumber : '';

    this.CustomerVehicleForm = new FormGroup({
      vehicleGroup:new FormControl(null),
      MakeName:new FormControl(null),
      Model:new FormControl(null),
      Year:new FormControl(''),
      fuelType:new FormControl(null),
      transmission:new FormControl(null),
      color:new FormControl(''),
      OwnerName:new FormControl(''),
      MobileNo: new FormControl(mobile,[Validators.required]),
      FirstName: new FormControl(null, [Validators.required, Validators.pattern(/^([^0-9])*$/)]),
      LastName: new FormControl(null, [Validators.required, Validators.pattern(/^([^0-9])*$/)]),
      Email: new FormControl(null, [Validators.required, Validators.pattern(Enums.RegexKeyCollection.CustomerEmail)]),
      Address1: new FormControl(null, [Validators.required]),
      Address2: new FormControl(null),
      City: new FormControl(null, [Validators.required]),
      CountryId: new FormControl(null, [Validators.required]),
      Zipcode: new FormControl(null, [Validators.required]),
      LicensePlate: new FormControl(registerNumber),
      VinNumber: new FormControl(vinNumber, [ Validators.pattern(/^[a-zA-Z0-9_ ]*$/)]),
      FirstRegDate: new FormControl(''),
      LastRegDate:new FormControl(''),
      InspectionPrevDate : new FormControl(''),
      InspectionNextDate: new FormControl(''),
    });
    if(this.localVehicleDetails !=null){
      this.addLocalCustomerVehicleFormPatchValue();
      this.isDFVehicleFound = false;
    }
    else if(this.vehicle != null){
      this.addCustomerVehicleFormPatchValue();
      this.isDFVehicleFound = false;
    }
    else{
      this.CustomerVehicleForm.controls.vehicleGroup.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.vehicleGroup.updateValueAndValidity();
      this.CustomerVehicleForm.controls.MakeName.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.MakeName.updateValueAndValidity();
      this.CustomerVehicleForm.controls.Model.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.Model.updateValueAndValidity();
      this.CustomerVehicleForm.controls.Year.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.Year.updateValueAndValidity();
      this.CustomerVehicleForm.controls.fuelType.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.fuelType.updateValueAndValidity();
      this.CustomerVehicleForm.controls.transmission.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.transmission.updateValueAndValidity();
      this.CustomerVehicleForm.controls.color.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.color.updateValueAndValidity();
      this.CustomerVehicleForm.controls.LicensePlate.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.LicensePlate.updateValueAndValidity();
      this.CustomerVehicleForm.controls.VinNumber.setValidators([Validators.required]);
      this.CustomerVehicleForm.controls.VinNumber.updateValueAndValidity();
    }
  }
  mask(phrase: string){
    if(phrase!= null && phrase!=undefined && phrase != ""){
      let length = phrase.length;
      let toBeReplaced = phrase.slice(4, length);
      let replacedtext = Array(length-4).join("X")
      return phrase.replace(toBeReplaced, replacedtext);
  }
  else return phrase;
}
addLocalCustomerVehicleFormPatchValue(){
  this.CustomerVehicleForm.patchValue({
    vehicleGroup:this.localVehicleDetails.vehicleType,
    MakeName:this.localVehicleDetails.companyMakeName,
    Model:this.localVehicleDetails.companyModel,
    Year:this.localVehicleDetails.year,
    fuelType:this.localVehicleDetails.fuelType,
    transmission:this.localVehicleDetails.transmission,
    color:this.localVehicleDetails.color,
    FirstRegDate:this.localVehicleDetails.firstRegistrationDate ? Utility.GetFormattedDate(new Date(this.localVehicleDetails.firstRegistrationDate)):null,
    LastRegDate:this.localVehicleDetails.lastRegistrationDate ? Utility.GetFormattedDate(new Date(this.localVehicleDetails.lastRegistrationDate)):null,
    InspectionNextDate:this.localVehicleDetails.nextInspectionDate ? Utility.GetFormattedDate(new Date(this.localVehicleDetails.nextInspectionDate)):null,
    InspectionPrevDate:this.localVehicleDetails.previousInspectionDate ? Utility.GetFormattedDate(new Date(this.localVehicleDetails.previousInspectionDate)):null
  });
  if(this.registrationNumber.length>= 11 )  //vin number entered, patch licence plate
   {
    this.CustomerVehicleForm.patchValue({
      LicensePlate:this.localVehicleDetails.licensePlateNo
    });
  }
   else{
    this.CustomerVehicleForm.patchValue({
    VinNumber:this.localVehicleDetails.chassisNo
    });
  }
}
  addCustomerVehicleFormPatchValue(){
    this.CustomerVehicleForm.patchValue({
      vehicleGroup:this.vehicle.vehicleGroup,
      MakeName:this.vehicle.brandName,
      Model:this.vehicle.modelName,
      Year:this.vehicle.modelYear,
      fuelType:this.vehicle.fuelTypeText,
      transmission:this.vehicle.transmission,
      color:this.vehicle.colorText,
      OwnerName: this.vehicle.ownerName,
      FirstRegDate:this.vehicle.firstRegistrationDate ? Utility.GetFormattedDate(new Date(this.vehicle.firstRegistrationDate)):null,
      LastRegDate:this.vehicle.lastRegistrationDate ? Utility.GetFormattedDate(new Date(this.vehicle.lastRegistrationDate)):null,
      InspectionNextDate:this.vehicle.nextInspectionDate ? Utility.GetFormattedDate(new Date(this.vehicle.nextInspectionDate)):null,
      InspectionPrevDate:this.vehicle.previousInspectionDate ? Utility.GetFormattedDate(new Date(this.vehicle.previousInspectionDate)):null
    });
    if(this.registrationNumber.length>= 11 )  //vin number entered, patch licence plate
    { this.CustomerVehicleForm.patchValue({
      LicensePlate:this.vehicle.plateNumber
      });
    }
  else{
    this.CustomerVehicleForm.patchValue({
    VinNumber:this.vehicle.vehicleIdentificationNumber
    });
    }
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  telInputObject() {
    if(this.vehicleCustomerDetailsMultiple != undefined)
    {
      let countryCode = this.getCountryCodeByDialCode(this.vehicleCustomerDetailsMultiple.customerDetails.mobileCode.toString());
      this.selectedCountryISO= countryCode || this.cultureLocaleService.getLocale();
    }
    else if(this.userInputMobilecode)
    {
      let countryCode = this.getCountryCodeByDialCode(this.userInputMobilecode);
      this.selectedCountryISO= countryCode || this.cultureLocaleService.getLocale();
    }
    else {
      let countryCode = this.getCountryCodeByDialCode(this.mobileCode);
      this.selectedCountryISO= countryCode || this.cultureLocaleService.getLocale();
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  onCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.userInputMobilecode = this.userInputMobilecode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userInputMobilecode = obj.dialCode;
    }
    this.commonService.addUserAuthMobileCode( this.userInputMobilecode);
    if(this.appData.customerDetails)
      this.appData.customerDetails.mobileCode = this.userInputMobilecode;
    }
}
